/**
 * 此文件由 scripts/extract-proto-enums.js 自动生成，请勿手动修改。
 * 从 protobuf .d.ts 中提取的枚举定义，用于替代运行时解构，实现 tree-shaking。 (@tencent/tpro_rmonitor_manage_server_domain_manage@1.0.2)
 */
/* eslint-disable @typescript-eslint/no-namespace -- 与 protobuf .d.ts 的 namespace 结构保持一致 */


/** Namespace trpc. */
export namespace trpc {
  /** Namespace rmonitor. */
  export namespace rmonitor {
    /** Namespace manage_server. */
    export namespace manage_server {
      export enum DomainBelongType {
        DOMAIN_BELONG_ALL = 0,
        DOMAIN_BELONG_SELF = 1,
        DOMAIN_BELONG_THIRD = 2,
        DOMAIN_BELONG_UNCLASSIFIED = 3,
      }
    }
  }
}
